import React from 'react';
import BlueXLoader from './BlueXLoader';
import './RoutePageLoader.css';

/** Suspense fallback while a lazy dashboard route/content chunk loads. */
export default function RoutePageLoader() {
  return (
    <div className="route-page-loader">
      <BlueXLoader size="large" label="Loading workspace" />
    </div>
  );
}
